<script setup lang="ts">
    const props = defineProps<{ blok: GFlexibleGridStoryblok }>();

    const { hidden } = useBlokVisibility(props.blok);

    const gridClasses = computed(() => {
        // Layout
        const chosenGridMobile = props.blok.gridMobile ? `--grid-mobile-${props.blok.gridMobile}` : '';
        const chosenGridTablet =
            props.blok.gridTablet && props.blok.gridTablet !== 'ignore' ? `--grid-tablet-${props.blok.gridTablet}` : '';
        const chosenGridDesktop =
            props.blok.gridDesktop && props.blok.gridDesktop !== 'ignore'
                ? `--grid-desktop-${props.blok.gridDesktop}`
                : '';
        const chosenVerticalAlignMobile =
            props.blok.verticalAlignMobile && props.blok.verticalAlignMobile !== 'top'
                ? `--vertical-align-mobile-${props.blok.verticalAlignMobile}`
                : '';
        const chosenVerticalAlignTablet =
            props.blok.verticalAlignTablet && props.blok.verticalAlignTablet !== 'top'
                ? `--vertical-align-tablet-${props.blok.verticalAlignTablet}`
                : '';
        const chosenVerticalAlignDesktop =
            props.blok.verticalAlignDesktop && props.blok.verticalAlignDesktop !== 'top'
                ? `--vertical-align-desktop-${props.blok.verticalAlignDesktop}`
                : '';
        const chosenHorizontalAlignMobile =
            props.blok.horizontalAlignMobile && props.blok.horizontalAlignMobile !== 'center'
                ? `--horizontal-align-mobile-${props.blok.horizontalAlignMobile}`
                : '';
        const chosenHorizontalAlignTablet =
            props.blok.horizontalAlignTablet && props.blok.horizontalAlignTablet !== 'center'
                ? `--horizontal-align-tablet-${props.blok.horizontalAlignTablet}`
                : '';
        const chosenHorizontalAlignDesktop =
            props.blok.horizontalAlignDesktop && props.blok.horizontalAlignDesktop !== 'center'
                ? `--horizontal-align-desktop-${props.blok.horizontalAlignDesktop}`
                : '';

        const revertMobileLayout = props.blok.revertMobileLayout ? '--revert-mobile-layout' : '';

        // Settings
        const widthClass = props.blok.width ? `--${props.blok.width}` : '';
        const marginClass = props.blok.margin !== 'default' ? `--margin-${props.blok.margin}` : '';
        const marginDesktopClass = props.blok.marginDesktop ? `--margin-desktop-${props.blok.marginDesktop}` : '';
        const paddingClass = `--padding-${props.blok.padding}`;
        const paddingDesktopClass = props.blok.paddingDesktop ? `--padding-desktop-${props.blok.paddingDesktop}` : '';
        const gapClass = props.blok.gap !== 'default' ? `--gap-${props.blok.gap}` : '';
        const gapDesktopClass =
            props.blok.gapDesktop && props.blok.gapDesktop !== 'default'
                ? `--gap-desktop-${props.blok.gapDesktop}`
                : '';

        // Themes
        const themeRoundCornersClass = props.blok.themeRoundCorners ? '--theme-round-corners' : '';
        const enforceRoundCornersClass = props.blok.enforceRoundCorners ? '--enforce-round-corners' : '';
        const hasBg = props.blok.theme !== 'default' ? '--has-bg' : '';
        const bgClass = props.blok.theme !== 'default' ? `--bg-color-${props.blok.theme}` : '';
        const bgPosition =
            props.blok.backgroundPosition !== 'default' ? `--bg-position-${props.blok.backgroundPosition}` : '';

        return [
            chosenGridMobile,
            chosenGridTablet,
            chosenGridDesktop,
            chosenVerticalAlignMobile,
            chosenVerticalAlignTablet,
            chosenVerticalAlignDesktop,
            chosenHorizontalAlignMobile,
            chosenHorizontalAlignTablet,
            chosenHorizontalAlignDesktop,
            revertMobileLayout,

            widthClass,
            marginClass,
            marginDesktopClass,
            paddingClass,
            paddingDesktopClass,
            gapClass,
            gapDesktopClass,

            themeRoundCornersClass,
            enforceRoundCornersClass,
            hasBg,
            bgClass,
            bgPosition
        ].filter(Boolean); // Removes any empty strings
    });
</script>

<template>
    <PreviewBorder :visibility="props.blok.visibility">
        <div
            v-if="!hidden"
            :id="props.blok.anchorId"
            v-editable="props.blok"
            class="grid-wrapper flexible-grid"
            :class="gridClasses"
        >
            <StoryblokComponentWrapper
                v-for="element in props.blok.content"
                :key="element._uid"
                :blok="element"
                class="sbc-wrapper"
            />
        </div>
    </PreviewBorder>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/grid/grid.scss';

    .sbc-wrapper {
        display: flex;
        flex-direction: column;
    }
</style>
